import { Type } from "class-transformer";
import { observable } from "mobx";
import Person from "./person";
import Vehicle from "./vehicle";
import VehicleOperator from "./vehicleOperator";

export enum SignatureType {
  DataBox = "DATA_BOX",
  ElectronicSignature = "ELECTRONIC_SIGNATURE",
  OfficiallyVerifiedSignature = "OFFICIALLY_VERIFIED_SIGNATURE",
}

export interface PersistedBase64 {
  id: string;
  fileName: string;
  fileSize: number;
  base64?: string;
}

export default class Notice {
  @Type(() => Person)
  @observable
  applicant: Person = new Person();

  @observable
  _signatureType: SignatureType = SignatureType.ElectronicSignature;

  @Type(() => Vehicle)
  @observable
  vehicle?: Vehicle = new Vehicle();

  @Type(() => VehicleOperator)
  @observable
  vehicleOperator?: VehicleOperator = new VehicleOperator();

  @observable
  _noticeBlob?: Blob;

  @observable
  _noticeBase64?: PersistedBase64;

  @observable
  _noticeURL?: string;

  @observable
  _powerOfAttorneyFilesBase64: PersistedBase64[] = [];

  @observable
  _technicalLicenseFilesBase64: PersistedBase64[] = [];
}
